<template>
  <div
    class="home xlbox"
    ref="articleRef"
    style="overflow-y: initial"
    id="mlinePage"
  >
    <van-nav-bar
      fixed
      title="线路"
      left-text=""
      right-text=""
      @click-left="onClickLeft"
    />
    <!-- <van-overlay :show="zshow" @click="zshow = false">
      <div class="wrapper" @click.stop>
        <ul  style="flex:1;border:1px solid red;height:100vh" class="xlUl" >
        <li v-for="(xlItem, index) in xlTree" :key="index" @click="toxlDiares">
          <span>{{xlItem.label}}</span>
          <p><span>行波模块：</span><i>{{xlItem.kgDtu}}</i><span>架空型：</span><i>{{xlItem.jkDtu}}</i><span>电缆型：</span><i>{{xlItem.dlDtu}}</i></p>
        </li>
      </ul>
      </div>
    </van-overlay> -->
    
    <van-popup
      v-model="zshow"
      overlay-class="xlPopup"
      get-container="app-page"
      position="right"
      :style="{
        width: '65%',
        margin: '23px 0 0 0',
        height: pageHeight + 50 + 'px',
      }"
    >
      <ul style="flex: 1; height: calc(100%-46px)" class="xlUl">
        <li
          v-for="(xlItem, index) in xlTree"
          :key="index"
          @click="toxlDiares(index)"
        >
          <span>{{ xlItem.label }}</span>
          <p>
            <span>行波模块：</span><i>{{ xlItem.kgDtu }}</i
            ><span>架空型：</span><i>{{ xlItem.jkDtu }}</i
            ><span>电缆型：</span><i>{{ xlItem.dlDtu }}</i>
          </p>
        </li>
      </ul>
    </van-popup>
    <van-search
    v-model="param"
    show-action
    placeholder="请输入搜索关键词"
    @search="onSearch"
    :clearable="false"
  >
    <template #action>
      <div @click="onSearch">搜索</div>
    </template>
  </van-search>
    <div class="app-page">
      <div class="item-box" v-for="(item, index1) in listTree" :key="index1">
        <div
          :class="[
            isExpanded && itemIndex == index1 ? 'expanded ' : '',
            'item-name',
          ]"
          @click="itemSelect(index1)"
        >
          <span
            ><van-icon
              :name="isExpanded && itemIndex == index1 ? src1 : src2"
            />{{ item.label }}</span
          >
          <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
        </div>
        <!-- 第2级 -->
        <div class="item-one" v-show="itemIndex == index1">
          <div
            class="item-one-child"
            v-for="(oneItem, index2) in item.children"
            :key="index2"
          >
            <div
              :class="[
                isExpanded2 && itemTwoIndex == index2 ? 'expanded ' : '',
                'child-name',
              ]"
              @click="itemTwoSelect(index2, oneItem.value, item.value, oneItem)"
            >
              <div style="flex: 1" :class="[
                oneItem.value.indexOf('E')<0 ? '' : 'flexClass'
              ]">
                <span>{{ oneItem.label }}</span>
                <!-- <p><span>变电站：</span><i>{{ oneItem.count }}</i></p> -->
                <!-- <p>{{oneItem}}</p>
                <p>{{index2}}</p> -->
                <p v-show="oneItem.value.indexOf('E')<0" >
                  <span>线路：</span><i>{{ oneItem.count }}</i>
                </p>
              </div>
              <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
            </div>


            <!-- 第3级  数据有4级的话才显示这1级 -->
            <!-- <span>{{oneItem}}</span> -->
            <div
              class="item-two"
              v-show="
                itemTwoIndex == index2&& oneItem.value.indexOf('E')>=0
              "
            >
              <div
                class="item-two-child"
                v-for="(twoItem, index3) in oneItem.children"
                :key="index3"
              >
                <div
                  :class="[
                    isExpanded3 && itemThreeIndex == index3 ? 'expanded ' : '',
                    'child-name',
                  ]"
                  @click="
                    itemThreeSelect(
                      index3,
                      twoItem.value,
                      oneItem.value
                    )
                  "
                >
                  <div style="flex: 1">
                    <span>{{ twoItem.label }}</span>
                    <p>
                      <span>线路：</span><i>{{ twoItem.count }}</i>
                    </p>
                  </div>
                  <i class="van-icon van-icon-arrow van-cell__right-icon"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import {
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Collapse,
  CollapseItem,
  Popup,
  Overlay,
  Toast,
  Search
} from "vant";

// import axios from 'axios' // 引入axios进行前后端交互
Vue.use(
  Col,
  Row,
  Button,
  NavBar,
  List,
  PullRefresh,
  Cell,
  CellGroup,
  DropdownMenu,
  DropdownItem,
  Icon,
  Collapse,
  CollapseItem,
  Popup,
  Overlay,
  Toast,
  Search
);

export default {
  name: "xlPage",
  components: {
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [NavBar.name]: NavBar,
    [List.name]: List,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Icon.name]: Icon,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Popup.name]: Popup,
    [Overlay.name]: Overlay,
    [Toast.name]: Toast,
    [Search.name]: Search,
  },
  data() {
    return {
      isExpanded: true,
      isExpanded2: true,
      isExpanded3: true,
      src1: require("../assets/xian-on@3x.png"),
      src2: require("../assets/xian@3x.png"),
      zshow: false,
      pageHeight: window.innerHeight - 95,
      xlTree: [],
      listTree: [],
      itemIndex: 0, // 默认展开第一层供电公司
      itemTwoIndex: 0, // 默认展开第一层供电所
      itemThreeIndex: 0, 
      mlineId: "", // 线路id
      xlIndex: "", // 点击线路的下标
      scrollTop: 0, // 在data属性中记录滚动的距离
      param:''
    };
  },
  created() {
    // alert(this.currentDate)
  },
  activated() {
    // console.log('activated' + this.scrollTop)
    // console.log(this.scrollTop)
    this.zshow = false;
    this.$refs.articleRef.scrollTop = this.scrollTop;
  },
  mounted() {
    this.getMlineTree();
    let article = this.$refs.articleRef; // 获取到根节点
    // 绑定onscroll事件，只要滚动鼠标就会触发该事件，记录滚动的值
    article.addEventListener("scroll", this.pageScroll, true);
  },
  methods: {
    onClickLeft() {
      this.$router.go(-1); // 返回上一页面
    },
    pageScroll() {
      // console.log(this.$refs.articleRef.scrollTop) // 有用就怪了
      this.scrollTop = this.$refs.articleRef.scrollTop;
    },
    toxlDiares: function (index) {
      this.xlIndex = index; // 点击线路的下标
      // console.log(this.xlTree[index].value)
      this.$router.push({
        path: "/xlDiaresPage",
        query: { mlineId: this.xlTree[index].value },
      }); // 跳转到线路详情页
    },
    // 第一层选择
    itemSelect: function (index1) {
      // console.log('第1层选择' + index1)
      if (this.itemIndex === index1) {
        // 折叠
        this.isExpanded = false;
        this.itemIndex = -1;
      } else {
        // 展开
        this.isExpanded = true;
        this.itemIndex = index1;
      }
      this.itemTwoIndex = -1; // 复位第二层的选择状态
    },
    // 第二层选择
    itemTwoSelect: function (index2, stationId1, eleoffId, item) {
      if (
        item.children[0].children[0] &&
        item.children[0].children[0].children
      ) {
        //有4级
        if (this.itemTwoIndex === index2) {
          // 折叠
          this.isExpanded3 = false;
          this.itemTwoIndex = -1;
        } else {
          // 展开
          this.isExpanded3 = true;
          this.itemTwoIndex = index2;
        }
        this.itemThreeIndex = -1; // 复位第二层的选择状态
      } else {
        //没有第4级
        this.zshow = true; // 显示线路遮罩
        // 根据局id、变电站id获取线路接口
        this.util
          .post("/getMlineByEleoffIdAndStationId1", {
            eleoffId: eleoffId,
            stationId1: stationId1,
          })
          .then(({ data }) => {
            if (data.code === 200) {
              this.xlTree = data.data.listTree;
              // var xlIndex = this.xlIndex
              // this.mlineId = data.data.listTree[xlIndex].value
            } else {
              return Promise.reject(
                new Error(data.message || data.msg || "系统错误，请稍后再试。")
              );
            }
          });
      }
    },
    // 第三层
    itemThreeSelect: function (index3, stationId1, eleoffId) {      
      this.zshow = true; // 显示线路遮罩
      // 根据局id、变电站id获取线路接口
      this.util
        .post("/getMlineByEleoffIdAndStationId1", {
          eleoffId: eleoffId,
          stationId1: stationId1,
        })
        .then(({ data }) => {
          if (data.code === 200) {
            this.xlTree = data.data.listTree;
            // var xlIndex = this.xlIndex
            // this.mlineId = data.data.listTree[xlIndex].value
          } else {
            return Promise.reject(
              new Error(data.message || data.msg || "系统错误，请稍后再试。")
            );
          }
        });
    },
    getMlineTree() {
      Toast.loading({
        message: "加载中...",
        forbidClick: true,
        loadingType: "spinner",
      });
      // 线路菜单接口
      this.util.post("/getMlineTree",{param:this.param}).then(({ data }) => {
        if (data.code === 200) {
          // console.log(data.data)
          this.listTree = data.data.listTree;
          // var xlIndex = this.xlIndex
          // this.mlineId = data.data.listTree[xlIndex].value
          Toast.clear(); // 手动清除 Toast
        } else {
          return Promise.reject(
            new Error(data.message || data.msg || "系统错误，请稍后再试。")
          );
        }
      });
    },
    onSearch(){
      this.getMlineTree()
    },
  },
  computed: {},
};
</script>

<style scoped lang="less">
/deep/.van-nav-bar {
  background: linear-gradient(227deg, #06c8b5 0%, #007cf8 100%);
}
/deep/.van-nav-bar__title {
  font-size: 17px;
  font-weight: bold;
  color: #fff;
}
/deep/.van-nav-bar .van-icon {
  font-size: 17px;
  color: #fff;
}
/deep/.van-cell__right-icon {
  margin-left: 4px;
  color: #969799;
  width: 30px;
  // height: 60px;
  // line-height: 60px;
}
/deep/.van-overlay {
  top: 45px;
  height: calc(100%-45px);
}
/deep/.van-popup {
  height: calc(100%-46px);
}
.home {
  padding-top: 46px;
  padding-bottom: 50px;
  height: calc(100% - 0px);
}
.app-page {
  overflow-x: hidden;
  display: block;
}
.item-name > i {
  height: 60px;
  line-height: 60px;
}
.child-name > i {
  height: 40px;
  line-height: 40px;
}
#mlinePage{
  height:100vh !important;
  overflow-y: scroll !important;
}
</style>
